
/* injects from baggage-loader */

import MemoryGameModule from './memory-game/memory-game.module';
import LogicGameModule from './logic-game/logic-game.module';
import DrawGameModule from './draw-game/draw-game.module';

const shared = angular.module('ui-module', [
	MemoryGameModule.name,
	LogicGameModule.name,
	DrawGameModule.name,
]);

export default shared;


// WEBPACK FOOTER //
// ./src/app/components/ui/ui.module.js